import { Link } from "react-router-dom"
import { Row, Col, VImage } from "../../style/base.style"
import {  GoogleLoginNew } from "../../hooks/socialAuth"
import { Colors } from "../../style/colors"
import { facebookIcon, googleIcon } from "../../constants/images"
import { useDictionary } from "../../contexts/dictionary"
import React, { useEffect } from "react"
import { useContactType } from "../../contexts/ContactContext"



interface SocialAuthComponentProps {
  setFormValues: React.Dispatch<React.SetStateAction<any>>
}

export const SocialAuthComponent = ({ setFormValues }: SocialAuthComponentProps) => {

  const { processGoogleAuth } = GoogleLoginNew()
  const { translate } = useDictionary()
  const handleClick = () => {
    handleGoogleLogin()
  }

  const handleGoogleLogin = async () => {
    const res = await processGoogleAuth()
    if (res) {
      setFormValues(res.data)
    }
  }
  return (
    <Row $width="100%" $justifyContent="center" $gap={20}>
      <Col $border={`1px solid${Colors.fieldBorder}`} $width="40%" $borderRadius={10}>
        <Link to="#" className="btn w-100" onClick={handleClick}>
          <VImage
            src={googleIcon}
            alt="google-icon"
            $width="auto"
          />
          {translate('sign_in_with_google')}
        </Link>
      </Col>
      <Col $border={`1px solid${Colors.fieldBorder}`} $width="40%" $borderRadius={10}>
        <Link to="#" className="btn w-100">
          <VImage
            src={facebookIcon}
            alt="fb-icon"
            $width="auto"
          />
          {translate('sign_in_with_facebook')}
        </Link>
      </Col>
    </Row>
  )
}